import * as _ from 'lodash';
import * as Yup from 'yup';

export function isTrue(value: any): boolean {
	if (_.isNil(value)) {
		return false;
	} else if (_.isBoolean(value)) {
		return value as boolean;
	} else if (_.isString(value)) {
		return /^true$/i.test(value);
	} else if (_.isNumber(value)) {
		return value === 0 ? false : true;
	} else {
		return false;
	}
}

export function mergeValidationSchemas(validationSchemas: Array<Yup.ObjectSchema<object, object>>) {
	if (validationSchemas.length === 1) {
		return validationSchemas[0];
	} else {
		const [first, ...rest] = validationSchemas;

		return rest.reduce((mergedSchemas, schema) => mergedSchemas.concat(schema), first);
	}
}



// WEBPACK FOOTER //
// ./src/utils.ts